import { UserState } from './user-reducer';
import { UserActions, USER_ACTION_TYPE } from './user-type';

export const userCreators = {
  setUserState: <KeyName extends keyof UserState>(key: KeyName, value: UserState[KeyName])
    : UserActions => ({
      type: USER_ACTION_TYPE.SET_USER_STATE,
      payload: { key, value }
    }),
  callUser: () => ({
    type: USER_ACTION_TYPE.CALL_USER
  }),
  callFilterBranch: (p: any) => ({
    type: USER_ACTION_TYPE.CALL_FILTER_BRANCH,
    param: p
  }),
};
